import { useEffect, useState } from 'react';
import { Api } from '../../../componentes/Api';
import { Card, CardBody,Row,Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter  } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';

const modeloDatos = {
   almacenID: 0, 
    empresaID: "",
    descripcion: "",
    ubicacionID: 1,
    activo:true,
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date
   
}

const InformesVentas = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [ListadoReporte, SetListadoReporte] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);

    const handleChange = (e) => {
        let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTabla({
            ...tabla,
            [e.target.name]: value
        })
    }


    const obtenerDatos = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaAlmacen");

        if (response.ok) {
            let data = await response.json()
            SetListado(data)
            setPendiente(false)
        }
    }
    const obtenerReportes = async () => {
        let response = await fetch(Api + "Administracion/Reporteria/3");

        if (response.ok) {
            let data = await response.json()
            SetListadoReporte(data)
        
        }
    }

    useEffect(() => {
        obtenerDatos();
        obtenerReportes()
    },[])

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }

    const columns = [
        {
            name: 'ID',
            selector: row => row.almacenID,
            sortable: true,
        },
        {
            name: 'Descripcion',
            selector: row => row.descripcion,
            sortable: true,
        },
       
       
        //{
        //    name: 'Estado',
        //    selector: row => row.esActivo,
        //    sortable: true,
        //    cell: row => {
        //        let clase;
        //        clase = row.esActivo ? "badge badge-info p-2" : "badge badge-danger p-2"
        //        return (
        //            <span className={clase}>{row.esActivo ? "Activo" : "No Activo"}</span>
        //        )
        //    }
        //}
        ,
        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                     onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>

                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };




    const CuadreCajaPV = () => {
       window.open("/ImpresionFactura/" + tabla.pedidoID, '_blank');;
    }
    const CuadreCajaNCF = () => {
        window.open("/impresionInventario/1" , '_blank');
    }
    const Reporte = (e) => {
        window.open("/impresionInventario/"+e, '_blank');
    }
   

    return (
        <>
            <div class="reporting-container">
             
                <button class="report-button inventory" onClick={() => CuadreCajaNCF()}>
                    <i class="fas fa-boxes"></i>  Lista de Articulos
                </button>
              
            </div>
            <div class="reporting-container">
            {ListadoReporte.map(x => (
                <button class="report-button inventory" onClick={() => Reporte(x.reporteID)}>
                    <i class="fas fa-boxes"></i>  {x.nombreBoton}
                </button>
                
            ))}
            </div>
        </>
        )

}
export default InformesVentas;